import React from "react";
import { HeroInfographicOverlay } from "./HeroInfographicOverlay";

export const HERO_INFOGRAPHIC_IMAGE_PATH = "/downloads/bimcubes-hero-reference.png";
export const HERO_INFOGRAPHIC_HTML_PATH = "/downloads/bimcubes-hero-infographic.html";

const revealDelays = [
  0.08, 0.18, 0.12, 0.28,
  0.22, 0.34, 0.26, 0.42,
  0.3, 0.46, 0.38, 0.54,
];

export const BimInfographic = () => {
  return (
    <div
      className="relative mx-auto w-[94vw] max-w-[1850px] overflow-hidden rounded-[2.9rem] border border-[#d9e7d5] bg-[#fbfdf8] shadow-[0_46px_140px_-70px_rgba(16,185,129,0.32)] lg:w-[92vw]"
      data-testid="marketing-infographic-wrapper"
    >
      <div
        className="absolute inset-0 bg-[radial-gradient(circle_at_top,_rgba(190,242,100,0.16),_transparent_26%),radial-gradient(circle_at_right,_rgba(94,234,212,0.14),_transparent_30%),linear-gradient(180deg,_#fcfef9_0%,_#f8fbf4_100%)]"
        data-testid="marketing-infographic-background"
      />
      <div className="relative aspect-[1672/941] w-full">
        <img alt="Infographie Bimcubes" className="h-full w-full object-contain" data-testid="marketing-infographic-image" src={HERO_INFOGRAPHIC_IMAGE_PATH} />
        <HeroInfographicOverlay />
        <div
          aria-hidden="true"
          className="absolute inset-0 grid grid-cols-4 grid-rows-3 pointer-events-none"
          data-testid="marketing-infographic-reveal-grid"
        >
          {revealDelays.map((delay, index) => (
            <span
              className="hero-reveal-cell"
              data-testid={`marketing-infographic-reveal-cell-${index + 1}`}
              key={index}
              style={{ "--hero-reveal-delay": `${delay}s` }}
            />
          ))}
        </div>
      </div>
    </div>
  );
};